import { setBookingProtectionInvalid } from 'actions/BookingProtectionActions'
import { addItem, removeItem, setBookingProtectionSelected } from 'actions/CheckoutActions'
import { getBookingProtectionItems } from 'checkout/selectors/view/bookingProtection'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useMemo } from 'react'

function useCheckoutBookingProtectionActions() {
  const dispatch = useAppDispatch()

  const bookingProtectionItems = useAppSelector(getBookingProtectionItems)

  const actions = useMemo(() => {
    function removeBookingProtectionItems(resetFormSchema: boolean): void {
      if (bookingProtectionItems.length) {
        bookingProtectionItems.forEach((item: App.Checkout.BookingProtectionItem) => {
          dispatch(removeItem(item.itemId, resetFormSchema))
        })
      }
    }

    function addBookingProtectionItem(newItem: App.Checkout.BookingProtectionItem): void {
      removeBookingProtectionItems(false)

      dispatch(addItem(newItem, true))
      dispatch(setBookingProtectionSelected(true))
      dispatch(setBookingProtectionInvalid(false))
    }

    return {
      removeBookingProtectionItems,
      addBookingProtectionItem,
    }
  }, [dispatch, bookingProtectionItems])

  return actions
}

export default useCheckoutBookingProtectionActions
